/* global pendo */
import * as commonHelpers from '../common';
import { isLoadedFromHiMarleyConnect } from '@app/helpers/platform';
import i18n, { DEFAULT_LOCALE } from '@app/i18n';

export const getGroupNames = (groups = [], groupLeads = []) => {
  const groupNames = groups?.map((group) => group.name) || [];
  const groupLeadNames = groupLeads?.map((groupLead) => groupLead.name) || [];
  return [...new Set([...groupNames, ...groupLeadNames])];
};

export const identify = (user) => {
  if (isLoadedFromHiMarleyConnect()) {
    return;
  }
  const org = user?.ownerOrganization;
  const { MARLEY_ACTIVE_ACCOUNT } = process.env;
  try {
    pendo.identify({
      visitor: {
        id: commonHelpers.getObjectId(user),
        displayName: `${user?.firstName} ${user?.lastName}`,
        email: user?.email,
        uniqueId: user?.oktaUserId,
        roles: user?.roles,
        groupNames: getGroupNames(user?.groups, user?.groupLeads),
        // drives Pendo Localization; `language` is reserved and keys off the
        // browser locale, so use our own field for the app's resolved locale
        preferredLanguage: i18n?.language || DEFAULT_LOCALE,
      },
      account: {
        id: commonHelpers.getObjectId(org),
        name: org?.name,
        creationDate: org?.createdAt,
        environment: MARLEY_ACTIVE_ACCOUNT,
        permissions: user?.permissions,
      },
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Pendo.js error', err);
  }
};

// Run identify() early; update locale again once resolved.
// Returns whether the locale reached Pendo, so callers can retry.
export const updateLanguage = (preferredLanguage) => {
  if (
    isLoadedFromHiMarleyConnect() ||
    !process.env.ENABLE_THIRD_PARTY_SCRIPTS ||
    typeof pendo === 'undefined'
  ) {
    return false;
  }
  try {
    pendo.updateOptions({ visitor: { preferredLanguage } });
    return true;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Pendo.js error', err);
    return false;
  }
};
